module.exports = __webpack_public_path__ + "img/3_user.3daf2005.svg";